export default {
reports_analytics: "Reports & Analytics",
total_revenue: "Total Revenue",
total_orders: "Total Orders",
products_sold: "Products Sold",
low_stock_items: "Low Stock Items",
products: "Products",
units: "Units",
currency: "QAR",

top_selling_products: "Top Selling Products",
product: "Product",
sold_qty: "Sold Qty",
revenue: "Revenue",
no_sales_data: "No sales data",

reports: "Reports",
select_report_module: "Select a report module",

inventory_report: "Inventory Report",
inventory_desc: "Stock, expiry & availability",

product_report: "Product Report",
product_desc: "Product master & status",

order_report: "Order Report",
order_desc: "Received orders",

invoice_report: "Invoice Report",
invoice_desc: "Generated invoices",

back_to_reports: "Back to Reports",
 productReport: "Product Report",
      excel: "Excel",
      pdf: "PDF",
      search: "Search product...",
      allStatus: "All Approval Status",
      pending: "Pending Approval",
      approved: "Approved",
      allStock: "All Stock",
      inStock: "In Stock",
      lowStock: "Low Stock",
      outOfStock: "Out of Stock",
      minStock: "Min stock",
      maxStock: "Max stock",
      noProducts: "No products found",
      loading: "Loading...",
      prev: "Prev",
      next: "Next",
      page: "Page",
      of: "of",
       table: {
    updated: "Updated",
    unit: "Unit",
    store: "Store",
    stock: "Stock",
    shelfLife: "Shelf Life",
    status: "Status",
    product: "Product",
    productId: "Product ID",
    price: "Price",
    expiryDate: "Expiry Date",
    currency: "Currency",
    createdAt: "Created At",
    company: "Company",
    category: "Category",
    branch: "Branch",
    productEn: "Product (EN)",
productAr: "Product (AR)",
  },
  supinventory: {
  title: "Inventory Report",
  product: "Product",
  stock: "Stock",
  status: "Status",
  expiry: "Expiry",
  updated: "Updated",
  allStock: "All Stock",
  allExpiry: "All Expiry",
  valid: "Valid",
  expiringSoon: "Expiring Soon",
  expired: "Expired"
},
orde: {
  title: "Order Report",
  orderId: "Order ID",
  date: "Date",
  status: "Status",
  payment: "Payment",
  product: "Product",
  qty: "Qty",
  price: "Price",
  total: "Total",
  allProducts: "All Products",
  allStatus: "All Status",
  allPayments: "All Payments"
}
}